import { useContext } from 'react';

import { PickListContext } from './Context';
import type { BaseGroup, BaseItem, PickListContextValue } from './type';

export const usePickListContext = <
  I extends BaseItem = BaseItem,
  G extends BaseGroup<I> = BaseGroup<I>,
>() => {
  const context = useContext(PickListContext);
  if (!context)
    throw new Error('usePickListContext must be used within a Provider');
  return context as unknown as PickListContextValue<I, G>;
};
